import React from "react"

import { OutlinedInput, InputAdornment, IconButton } from "@material-ui/core";

import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const CustomInputField = (props) => {
    const { classes, element, dataObj, onChange, styles, selectedStep, inputClasses } = props
    const getValueFromPath = (obj, path) => {
        if (!path) return undefined;
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
    };

    const rawValue = getValueFromPath(dataObj, element.value) || dataObj[element.name];

    let displayValue = rawValue || "";

    if (element.showPoundIcon) {
        if (typeof displayValue === "string") {
            // Remove pound and commas
            displayValue = displayValue.replace(/£/g, "").replace(/,/g, "").trim();
        }

        const numericVal = parseFloat(displayValue);

        displayValue = !isNaN(numericVal)
            ? `£${numericVal.toLocaleString("en-GB", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            })}`
            : "£0.0";
    }
    else if (element.showPercentageIcon) {
        if (typeof displayValue === "string") {
            displayValue = displayValue.replace(/%/g, "").trim();
        }
        let numericVal = parseFloat(displayValue);

        if (!isNaN(numericVal)) {
            // if value looks like a fraction (0–1), convert to %
            if (numericVal <= 1) {
                numericVal = numericVal * 100;
            }

            displayValue = `${numericVal.toLocaleString("en-GB", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            })}%`;
        } else {
            displayValue = "0.0%";
        }
    }

    const handleViewClick = (viewUrl, displayValue) => {
        if (viewUrl && displayValue) {
            window.open(`${window.location.origin}/${props?.match?.params?.appid}/page/${element.viewUrl}/${displayValue}`, '_blank');
        }
    };

    return (
        <OutlinedInput
            id={`${element.name}`}
            variant="outlined"
            style={{
                width: "100%",
                height: "32px",
                padding: '5px 8px 6px 8px'
            }}
            classes={{
                root: inputClasses?.smallOutlinedInput,
                notchedOutline: inputClasses?.smallNotchedOutline,
            }}
            required={element.required}
            key={element.value || element.name}
            name={element.value || element.name}
            disabled={element.readOnly}
            type={element.type}
            value={displayValue}
            title={displayValue}
            onChange={(e) => {
                onChange((element.value || element.name), e.target.value, element.type);
            }}
            endAdornment={
                element?.isViewEnable && displayValue && displayValue !== "" ? (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => { handleViewClick(element?.viewUrl, displayValue) }}
                            edge="end"
                            size="small"
                            style={{ padding: '0px', minWidth: '20px', width: '20px', height: '20px' }}
                        >
                            <OpenInNewIcon fontSize="small" style={{ fontSize: '18px' }} />
                        </IconButton>
                    </InputAdornment>
                ) : null
            }
        />
    )
}

export default CustomInputField